import { AxiosError } from 'axios';

// import { reportCustomError } from '@/utils/feishu';

// /**
//  * 构建错误堆栈信息
//  */
// function buildErrorStack(requestConfig: any, additionalInfo: Record<string, any> = {}): string {
//   const { url, method = 'GET', params, data } = requestConfig;
//   const stackParts: string[] = [`请求地址: ${url || 'N/A'}`, `请求方法: ${method}`];

//   // 添加额外信息
//   Object.entries(additionalInfo).forEach(([key, value]) => {
//     if (value !== null && value !== undefined) {
//       stackParts.push(`${key}: ${value}`);
//     }
//   });

//   // 添加请求参数
//   if (params && Object.keys(params).length > 0) {
//     stackParts.push(`请求参数: ${JSON.stringify(params)}`);
//   }
//   if (data && Object.keys(data).length > 0) {
//     stackParts.push(`请求体: ${JSON.stringify(data)}`);
//   }

//   return stackParts.join('\n');
// }

// /**
//  * 识别网络错误类型
//  */
// function getNetworkErrorType(error: any): string {
//   const errorCode = error?.code;
//   const errorMessage = error?.message?.toLowerCase() || '';

//   if (errorCode === 'ECONNABORTED' || errorMessage.includes('timeout')) {
//     return '请求超时';
//   }
//   if (errorCode === 'ERR_NETWORK' || error?.message === 'Network Error') {
//     return '网络连接失败';
//   }
//   if (errorCode === 'ERR_INTERNET_DISCONNECTED') {
//     return '网络断开';
//   }
//   if (!error?.response && error?.request) {
//     return '无响应（弱网环境）';
//   }
//   return '网络错误';
// }

// /**
//  * 上报业务错误到飞书
//  */
// function reportBizError(apiResponse: IApiResponse, requestConfig: any) {
//   const { message, errorType, requestId, data: responseData } = apiResponse;
//   const errorMessage = message || '未知错误';

//   // 过滤掉业务错误（BIZ_ERROR），这类错误是预期的业务逻辑错误，不需要上报
//   if (errorType === 'BIZ_ERROR') {
//     return;
//   }

//   const additionalInfo: Record<string, any> = {};
//   if (errorType) additionalInfo['错误类型'] = errorType;
//   if (requestId) additionalInfo['请求ID'] = requestId;
//   if (responseData !== null && responseData !== undefined) {
//     additionalInfo['响应数据'] = JSON.stringify(responseData);
//   }

//   const stack = buildErrorStack(requestConfig, additionalInfo);

//   // 上报到 CLS
//   error(new Error(`接口业务错误: ${errorMessage}`), {
//     errorType: errorType || 'biz-error',
//     requestId,
//     url: requestConfig.url,
//     method: requestConfig.method,
//     params: requestConfig.params ? JSON.stringify(requestConfig.params) : undefined,
//     data: requestConfig.data ? JSON.stringify(requestConfig.data) : undefined,
//     responseData: responseData !== null && responseData !== undefined ? JSON.stringify(responseData) : undefined,
//   });

//   reportCustomError(`接口业务错误: ${errorMessage}`, {
//     errorType: 'custom-error',
//     stack,
//   });
// }

// /**
//  * 上报网络错误到飞书
//  */
// function reportNetworkError(error: any, requestConfig: any) {
//   const errorCode = error?.code;
//   const errorMessage = error?.message || '未知网络错误';
//   const errorTypeLabel = getNetworkErrorType(error);

//   const additionalInfo: Record<string, any> = {
//     错误代码: errorCode || 'N/A',
//     错误消息: errorMessage,
//   };

//   if (error?.response?.status) {
//     additionalInfo['响应状态码'] = error.response.status;
//   }
//   if (error?.response?.statusText) {
//     additionalInfo['响应状态文本'] = error.response.statusText;
//   }

//   const stack = buildErrorStack(requestConfig, additionalInfo);

//   // 上报到 CLS（优先使用原始 Error 对象）
//   const errorObj = error instanceof Error ? error : new Error(`接口${errorTypeLabel}: ${errorMessage}`);
//   error(errorObj, {
//     errorType: errorTypeLabel,
//     errorCode: errorCode || undefined,
//     url: requestConfig.url,
//     method: requestConfig.method,
//     params: requestConfig.params ? JSON.stringify(requestConfig.params) : undefined,
//     data: requestConfig.data ? JSON.stringify(requestConfig.data) : undefined,
//     statusCode: error?.response?.status,
//     statusText: error?.response?.statusText,
//   });

//   reportCustomError(`接口${errorTypeLabel}: ${errorMessage}`, {
//     errorType: 'custom-error',
//     stack,
//   });
// }

// /**
//  * 判断是否为网络相关错误
//  */
// function isNetworkError(error: any): boolean {
//   const networkErrorCodes = [
//     'ECONNABORTED',
//     'ERR_NETWORK',
//     'ERR_INTERNET_DISCONNECTED',
//     'ERR_CONNECTION_REFUSED',
//     'ERR_CONNECTION_RESET',
//     'ERR_CONNECTION_TIMED_OUT',
//   ];

//   return (
//     !error?.response ||
//     networkErrorCodes.includes(error?.code) ||
//     error?.message === 'Network Error' ||
//     error?.message?.toLowerCase().includes('timeout') ||
//     (error?.request && !error?.response)
//   );
// }

export function setResponseInterceptor(error: AxiosError): void {
  // 提取请求配置
  // const requestConfig = {
  //   url: (error.config?.baseURL || '') + (error.config?.url || ''),
  //   method: error.config?.method?.toUpperCase(),
  //   params: error.config?.params,
  //   data: error.config?.data,
  // };

  const responseData = error?.response?.data as IApiResponse | undefined;

  // 1. 业务错误：接口返回了响应，但 success 为 false
  if (responseData && typeof responseData === 'object' && !responseData.success) {
    // reportBizError(responseData as IApiResponse, requestConfig);
    throw new Error(responseData.message || '接口请求失败');
  }

  // // 2. 网络错误：没有响应或网络相关错误
  // if (isNetworkError(error)) {
  //   reportNetworkError(error, requestConfig);
  //   throw error;
  // }

  // // 3. HTTP 状态码错误（4xx, 5xx）
  // if (error?.response?.status >= 400) {
  //   reportNetworkError(error, requestConfig);
  //   throw error;
  // }

  // 其他未知错误
  throw error;
}
